import AbstractAlGuestlistEditorPagesController from '../../abstracts/abstract-page-controller';

export default class AlGuestlistEditorPageGeneralComponentController extends AbstractAlGuestlistEditorPagesController {

    constructor($injector, $scope) {
        super($injector, $scope);
        this.model = {};
    }

    /**
     * Removes the specified user from the selected permissions
     *
     * @param userToDelete
     */
    removeUser(userToDelete, target) {
        const indexToDelete = this.model.settings[target].indexOf(userToDelete);

        if (indexToDelete !== -1) {
            this.model.settings[target].splice(indexToDelete, 1);
        }
    }

    /**
     * Opens popup to add new users to the guestlist permissions list
     */
    addUsers(target) {
        this.injector.get('SelectBox')
            .single(this.injector.get('Users')
                .reset({
                    persists: false,
                    listname: 'GuestlistPermissionUserSelectList'
                }), {
                displayField: 'master_user.full_name'
            })
            .then((selectedUserData) => {
                const present = _.filter(this.model.settings[target], function (user) {
                    return user.id === selectedUserData.data;
                });

                if (present.length === 0) {
                    this.injector.get('User').get(selectedUserData.data).then((fullUser) => {
                        this.model.settings[target].push({id:fullUser.id, full_name: fullUser.full_name});
                    });
                } else {
                    this.injector.get('Alert').warning(this.translate.instant(`guestlists.editor.pages.general.alerts.user_already_exists_in_permissions_list`));
                }
            });
    }

    /**
     * @private
     */
    _fillModelFromGuestlist() {
        this.model = _.cloneDeep({
            settings: {
                reports_active: this.getGuestlistValue('settings.reports_active'),
                reports_notify_users: this.getGuestlistValue('settings.reports_notify_users'),
                registration_about_to_end_active: this.getGuestlistValue('settings.registration_about_to_end_active'),
                registration_about_to_end_notify_users: this.getGuestlistValue('settings.registration_about_to_end_notify_users'),
            },
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-editor/pages/notifications/controller.js